<template>
    <div class="work_order">
        <Top></Top>
        <div class="container" style="min-height: 750px">
            <h1 style="margin-bottom: 10px">{{ $t('m.my.workOrder.detail.title[0]') }}</h1>
            <!--<div class="detail_title">{{ $t('m.my.workOrder.detail.title[1]') }}</div>-->
            <div class="information_container">
                <div class="detail_item">
                    <div class="first">{{ $t('m.my.workOrder.detail.text[0]') }}:</div>
                    <div class="last">{{ detail.number }}</div>
                </div>
                <div class="detail_item">
                    <div class="first">{{ $t('m.my.workOrder.detail.text[4]') }}:</div>
                    <div class="last">{{ $i18n.locale == 'zh-CN' ? detail.cate_name : detail.en_cate_name }}</div>
                </div>
                <!--<div style="display: flex;justify-content: space-between">
                    <div class="detail_item" style="width: 45%">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[1]') }}:</div>
                        <div class="last">{{ detail.account }}</div>
                    </div>
                    <div class="detail_item" style="width: 45%">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[2]') }}:</div>
                        <div class="last">{{ detail.mobile }}</div>
                    </div>
                </div>
                <div style="display: flex;justify-content: space-between">
                    <div class="detail_item" style="width: 45%">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[3]') }}:</div>
                        <div class="last">{{ detail.email }}</div>
                    </div>
                    <div class="detail_item" style="width: 45%">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[4]') }}:</div>
                        <div class="last">{{ $i18n.locale == 'zh-CN' ? detail.cate_name : detail.en_cate_name }}</div>
                    </div>
                </div>-->
                <!--<div class="detail_item" style="min-height: 200px">
                    <div class="first">{{ $t('m.my.workOrder.detail.text[5]') }}:</div>
                    <div class="last">{{ detail.description }}</div>
                </div>
                <div class="detail_item">
                    <div class="first">{{ $t('m.my.workOrder.detail.text[6]') }}:</div>
                    <div class="last" style="background: transparent">
                        <img v-for="(v,k) in detail.b_imgs" :key="k"
                             :src="requestConfig.host + v"
                             @click="myOpen(requestConfig.host + v)">
                    </div>
                </div>-->
            </div>
            <!--<div class="detail_title" v-show="detail.history.length == 0">{{ $t('m.my.workOrder.detail.title[2]') }}</div>-->
            <div class="information_container">
                <template v-for="h in detail.history">
                    <div class="detail_item">
                        <div class="first">{{ h.is_reply == 0 ? $t('m.my.workOrder.detail.text[5]') : $t('m.my.workOrder.detail.text[7]') }}:</div>
                        <div class="last">{{ h.content }}</div>
                    </div>
                    <div class="detail_item" v-show="h.b_imgs.length > 0">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[8]') }}:</div>
                        <div class="last" style="background: transparent">
                            <img v-for="v in h.b_imgs"
                                 :src="requestConfig.host + v"
                                 @click="myOpen(requestConfig.host + v)">
                        </div>
                    </div>
                    <!--<div class="detail_item" style="margin-top: 40px">
                        <div class="first">{{ $t('m.my.workOrder.detail.text[9]') }}:</div>
                        <div class="last">{{ h.answer_time }}</div>
                    </div>-->
                </template>
            </div>
            <!--<div v-else
                 class="information_container"
                 style="line-height: 200px">
                <div style="text-align: center;font-size: 14px">{{ $t('m.my.workOrder.detail.text[10]') }}</div>
            </div>-->
            <div style="max-width: 650px">
                <div @click="changeRoute('/workOrder', {wid: detail.wid,wcid: detail.wcid})"
                        class="detail_confirm">{{ $t('m.my.workOrder.communicate') }}</div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top';
    import Bottom from '@/components/bottom';

    export default {
        name: "workOrderDetail",
        components: {
            Top, Bottom
        },
        data() {
            return {
                detail: {},
                wid: ""
            }
        },
        created() {
            this.wid = this.$route.query.wid;
            this.getDetail();
        },
        methods: {
            getDetail() {
                let paramData = this.signRequest({
                  wid: this.wid
                });
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/Workorder/myWorkOrder", {
                    params: paramData
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    console.log(res);
                    this.detail = res.list.data[0];
                    /*this.detail.b_imgs = this.detail.b_imgs ? JSON.parse(this.detail.b_imgs) : '';
                    this.detail.answer_imgs = this.detail.answer_imgs ? JSON.parse(this.detail.answer_imgs) : '';*/
                    this.userInfo.count = res.count;
                    if (this.detail.history.length > 0) {
                        for (let i in this.detail.history ) {
                            this.detail.history[i].b_imgs = this.detail.history[i].b_imgs ? JSON.parse(this.detail.history[i].b_imgs) : '';
                        }
                    }
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.$message.error(this.$t('m.common.order.text[0]'));
                });
            },
            myOpen(url) {
                window.open(url);
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/css/work_order.scss";
    .detail_title {
        font-size: 18px;
    }
    .information_container {
        /*padding: 20px 0;*/
        max-width: 650px;
        .detail_item {
            /*height: 30px;*/
            line-height: 30px;
            display: flex;
            font-size: 14px;
            margin-bottom: 20px;
            .first {
                width: 100px;
                text-align: right;
            }
            .last {
                width: calc(100% - 110px);
                margin-left: 10px;
                word-wrap:break-word;
                background: #F2F2F2;
                img {
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    cursor: pointer
                }
            }
        }
    }
    .detail_confirm {
        width: 190px;
        background-color: #0072EF;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 400;
        line-height: 2.72;
        min-width: 190px;
        text-align: center;
        margin: 25px auto 0;
        cursor: pointer;
    }
</style>
